/**
 * 敏感字段脱敏工具
 */
export class MaskingMiddleware {
  private static readonly PASSWORD_KEYS = /password|passwd|pwd|token|secret/i;
  private static readonly MOBILE_KEYS = /mobile|phone|cellphone/i;
  private static readonly IDCARD_KEYS = /idcard|id_card|identity_card/i;
  private static readonly BANKCARD_KEYS = /bankcard|bank_card|credit_card/i;

  public mask(data: any): any {
    return this.maskValue(data, new WeakSet<object>(), 0);
  }

  private maskValue(data: any, ancestors: WeakSet<object>, depth: number): any {
    if (typeof data === 'function') {
      throw new Error('Executable tracking properties are not supported');
    }
    if (data === null || typeof data !== 'object') {
      return data;
    }
    if (depth > 32 || ancestors.has(data)) {
      throw new Error('Unsafe tracking property structure');
    }
    ancestors.add(data);
    try {
      if (Array.isArray(data)) {
        return data.map((item) => this.maskValue(item, ancestors, depth + 1));
      }
      const maskedObj: Record<string, any> = Object.create(null);
      for (const [key, value] of Object.entries(data)) {
        maskedObj[key] = this.maskField(key, value, ancestors, depth);
      }
      return maskedObj;
    } finally {
      ancestors.delete(data);
    }
  }

  private maskField(key: string, value: any, ancestors: WeakSet<object>, depth: number): any {
    if (value === null || value === undefined) {
      return value;
    }

    if (MaskingMiddleware.PASSWORD_KEYS.test(key)) {
      return '******';
    }
    if (typeof value === 'object' || typeof value === 'function') {
      return this.maskValue(value, ancestors, depth + 1);
    }

    const strVal = String(value);

    if (MaskingMiddleware.MOBILE_KEYS.test(key) && strVal.length === 11) {
      return strVal.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
    }

    if (MaskingMiddleware.IDCARD_KEYS.test(key) && (strVal.length === 18 || strVal.length === 15)) {
      return strVal.replace(/^(\d{6})\d+(\d{4})$/, '$1********$2');
    }

    if (MaskingMiddleware.BANKCARD_KEYS.test(key) && strVal.length >= 16) {
      return strVal.replace(/^(\d{4})\d+(\d{4})$/, '$1********$2');
    }

    return value;
  }
}
